module.exports = __webpack_public_path__ + "img/service_img_5.b03cf742.png";